import { stringify } from 'query-string';
import formatCalendarDate from '../formatCalendarDate';

export const GOOGLE_CALENDAR_URL = 'https://calendar.google.com/calendar/render';

// See https://github.com/InteractionDesignFoundation/add-event-to-calendar-docs/blob/master/services/google.md
const createGoogleCalendarLink = ({ startDate, endDate, location, title, description }) => {
  const query = stringify({
    action: 'TEMPLATE',
    dates: `${formatCalendarDate(startDate)}/${formatCalendarDate(endDate)}`,
    location,
    text: title,
    details: description,
  });

  return `${GOOGLE_CALENDAR_URL}?${query}`;
};

export default createGoogleCalendarLink;
